import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import Search from "@insite/mobius/Icons/Search";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(searchBoxStyles, {
    search: {
        iconProps: {
            src: Search,
            css: css`
                background: ${COLORS.white};
                position: absolute;
                box-sizing: border-box;
                top: 2px;
                right: 2px;
                width: 36px;
                height: 36px;
                padding: 8px;
                border-radius: 100%;
                pointer-events: none;
            `,
        },
    },
});
